import axios from 'axios';
import { Task, CreateTaskDto, UpdateTaskDto } from '../types/Task';

const API_BASE_URL = 'http://localhost:5116/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const taskService = {
  getAllTasks: async (): Promise<Task[]> => {
    const response = await api.get<Task[]>('/tasks');
    return response.data;
  },

  getTaskById: async (id: number): Promise<Task> => {
    const response = await api.get<Task>(`/tasks/${id}`);
    return response.data;
  },

  createTask: async (taskDto: CreateTaskDto): Promise<Task> => {
    const response = await api.post<Task>('/tasks', taskDto);
    return response.data;
  },

  updateTask: async (id: number, taskDto: UpdateTaskDto): Promise<void> => {
    await api.put(`/tasks/${id}`, taskDto);
  },

  deleteTask: async (id: number): Promise<void> => {
    await api.delete(`/tasks/${id}`);
  },

  toggleTaskCompletion: async (id: number, isCompleted: boolean): Promise<void> => {
    await api.put(`/tasks/${id}`, { isCompleted });
  },
};